import Api from '@/api/api'
import apiCommonUrl from '@/api/apiCommonUrl'

export default {
     getIOTServices() {
        return apiCommonUrl.get(`/exposer/ExternalService/GetExternalService`);
    },
    getInitialData() {
        return Api.get(`/api/InitialData/GetSuperAdminInitialData`);
    },
    getDeviceById(deviceId) {
        return Api.get(`/api/Device/GetDeviceByID/${deviceId}`);
    },
    getIOTById(iotId)
    {
         return apiCommonUrl.get(`/exposer/ExternalService/GetExternalServiceByIds/${iotId}`);
    },
    updateDevice(id, IOTData) {
        //return apiCommonUrl.put(`/exposer/ExternalService/UpdateExternalService/${id}`, IOTData);
        return apiCommonUrl.put(`/exposer/ExternalService/UpdateExternalService?userId=` + id, IOTData);
    },
    addDevice(data) {
        return apiCommonUrl.post(`/exposer/ExternalService/AddExternalService`, data);
    },
    deleteIOTDevice(deleteId) {
        return apiCommonUrl.delete(`/exposer/ExternalService/DeleteExternalService/${deleteId}`);
    },
}